import { MultiSelect } from "components/Select";
import { useRoleContext, useShipmentFiltersContext } from "hooks";

import type { SelectProps } from "@mui/material";

const OPTIONS = [
  {
    value: "ALL",
    label: "All",
  },
  {
    value: "SINGLE",
    label: "Single",
  },
  {
    value: "MULTI_SHIPMENT_PROJECT",
    label: "Multi-Shipment Project",
  },
  {
    value: "QUOTES_ONLY",
    label: "Quotes Only Shipments",
  },
];

interface Props {
  width?: string;
  selectProps?: SelectProps;
  label?: string;
}

export function FilterShipmentByTypeDropdown(props: Props = {}) {
  const { width, selectProps, label } = props;
  const { filters, updateShipmentType } = useShipmentFiltersContext();

  const { role } = useRoleContext();

  if (role == null) {
    return null;
  }

  const handleShipmentTypeChange = (value: string[]) => {
    updateShipmentType(value);
  };

  return (
    <MultiSelect
      inputLabel={label ?? "Shipment Types"}
      defaultValue={filters?.shipmentTypes ?? []}
      value={filters?.shipmentTypes ?? []}
      onChange={handleShipmentTypeChange}
      options={OPTIONS}
      width={width}
      selectProps={selectProps}
    />
  );
}
